module.exports = __webpack_public_path__ + "static/media/icon-delete.0e933289.svg";